/**
 * Device-aware CDN video source.
 *
 * The landing-page videos on cdn.pixro.ai have two compressed variants:
 *   <uuid>-d.mp4  → desktop (1080p)
 *   <uuid>-m.mp4  → mobile  (720p, much smaller)
 * (the original <uuid>.mp4 is kept untouched as a fallback).
 *
 * `cdnVideoSrc` rewrites an original cdn.pixro.ai `.mp4` URL to the right
 * variant for the device. Non-cdn URLs, non-mp4 URLs, and URLs that are already
 * a variant are returned unchanged. Callers should also keep the original URL as
 * a `<source>` fallback so a missing variant degrades gracefully.
 */
export function cdnVideoSrc(url: string, isMobile: boolean): string {
    if (
        !url ||
        !url.includes("cdn.pixro.ai/") ||
        !url.endsWith(".mp4") ||
        /-[dm]\.mp4$/.test(url)
    ) {
        return url;
    }
    return url.replace(/\.mp4$/, isMobile ? "-m.mp4" : "-d.mp4");
}
